import { Directive, Input, TemplateRef, ViewContainerRef } from '@angular/core';
import { UserState } from 'src/app/_user/store/user/user.state';
import { Store } from '@ngxs/store';

@Directive({
    selector: '[appHasVersion]',
    standalone: false
})
export class HasVersionDirective {

    constructor(private readonly store: Store,
                private readonly viewContainerRef: ViewContainerRef,
                private readonly templateRef: TemplateRef<any>) {
    }

    @Input()
    set appHasVersion(version: number) {

        const hasModules = this.store.selectSnapshot(UserState.hasVersion)?.(version) ?? false;

        if (hasModules) {
            this.viewContainerRef.createEmbeddedView(this.templateRef);
        } else {
            this.viewContainerRef.clear();
        }
    }
}
